exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-custom[data-v-a3747288] {\n  font-size: 0.75rem;\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n  margin: 0;\n  font-weight: 400;\n  letter-spacing: 0.075rem;\n  vertical-align: top;\n}", ""]);

// exports
